export class ContextMetadata {
  isMultiSector: boolean;
  isMultiIndustry: boolean;
  isMultiOccupation: boolean;
  isMultiProduct: boolean;

  constructor(
    isMultiSector: boolean,
    isMultiIndustry: boolean,
    isMultiOccupation: boolean,
    isMultiProduct: boolean
  ) {
    this.isMultiSector = isMultiSector;
    this.isMultiIndustry = isMultiIndustry;
    this.isMultiOccupation = isMultiOccupation;
    this.isMultiProduct = isMultiProduct;
  }
}
